module.exports = __webpack_public_path__ + "static/media/gb.7b03603e.svg";